import type { ApiResult } from './api-client.ts';
import type { DelegaAltroTerritorioBodyInput } from './api/deleghe-altri-territori.ts';
import type { LavoratoreCompleto } from '@/types/entities/ricerca.ts';

/** Nominativo scelto nel form Altri territori: dall'anagrafica (`lavoratoreId`) o inserito a mano */
export interface Nominativo {
  lavoratoreId: number | null;
  codiceFiscale: string;
  cognome: string;
  nome: string;
  dataNascita: string | null;
  collegatoDaCf?: boolean;
}

type BodyNominativo = Pick<DelegaAltroTerritorioBodyInput, 'lavoratoreId' | 'codiceFiscale' | 'cognome' | 'nome' | 'dataNascita'>;

export const oggi = (): string => new Date().toLocaleDateString('sv-SE');

export const daLavoratore = (l: LavoratoreCompleto, collegatoDaCf = false): Nominativo => ({
  lavoratoreId: l.id,
  codiceFiscale: l.codiceFiscale ?? '',
  cognome: l.cognome,
  nome: l.nome,
  dataNascita: l.dataNascita,
  collegatoDaCf,
});

/** Il CF va sempre (serve se l'anagrafica non lo ha); la data di nascita solo se c'è: vuota non passa la validazione */
export function bodyNominativo(n: Nominativo): BodyNominativo {
  const cf = n.codiceFiscale ? { codiceFiscale: n.codiceFiscale } : {};
  if (n.lavoratoreId) return { lavoratoreId: n.lavoratoreId, ...cf };
  return { ...cf, cognome: n.cognome, nome: n.nome, ...(n.dataNascita ? { dataNascita: n.dataNascita } : {}) };
}

/** Errori di validazione Zod per campo, altrimenti il messaggio del servizio */
export const messaggioErrore = (result: Extract<ApiResult, { ok: false }>): string =>
  result.errori?.length ? result.errori.map(e => e.messaggio).join('; ') : result.error;
